module.exports = __webpack_public_path__ + "static/media/  (57).db3b5cfa.jpg";